import React from 'react';

import {
  Container,
  Header,
  PartnerLink,
  Content,
  Title,
  Logo,
  TextWrapper,
  HighlightTitle,
  SubTitle,
  Text,
  Arrow,
} from './styles';

import BecomePartnerForm from '../BecomePartnerForm';

function HeaderSection() {
  return (
    <Container>
      <Header>
        <a href="https://precatoriosbrasil.com/" target="blank">
          <Logo />
        </a>
        <PartnerLink href="https://officer.precatoriosbrasil.com/">
          <Arrow />
          Já sou parceiro
        </PartnerLink>
      </Header>
      <Content>
        <TextWrapper>
          <div>
            <Title>Amplie sua rede de negócios e seja</Title>
            <HighlightTitle>Um parceiro da precatórios brasil</HighlightTitle>
            <SubTitle>Powered by btg pactual</SubTitle>
          </div>
          <Text>
            A Precatórios Brasil conta com toda a estrutura e segurança do BTG
            Pactual, maior banco de investimento da América Latina.
          </Text>
          <Text>
            Mantenha seu cadastro atualizado para receber informações, novidades
            e oportunidades que a Precatórios Brasil encontra para você
            prospectar clientes!
          </Text>
        </TextWrapper>
        <PartnerLink small href="https://officer.precatoriosbrasil.com/">
          <Arrow />
          Já sou parceiro
        </PartnerLink>
        {/*<BecomePartnerForm />*/}
      </Content>
    </Container>
  );
}

export default HeaderSection;
